import Markdown from "react-markdown";
import { image } from "../../../assets";

export const GptMessage = ({ text, imageAvatar }) => {
  const icoed360 = image.icoed360;
  const imageUrl = imageAvatar ? `${imageAvatar}` : `${icoed360}`;

  //console.log("GptMessage -> imageUrl", `${ENV.BASE_PATH}/${imageAvatar}`);
  return (
    <div className="col-start-1 col-end-9 p-3 rounded-lg flex gpt-message">
      <img src={imageUrl} alt="Avatar" className="gpt-avatar" />
      <div className="gpt-bubble">
        <Markdown>{text}</Markdown>
      </div>
    </div>
  );
};
